import React, { useState } from "react";
import { Modal, Box, Typography, TextField, Button, Fade, Backdrop } from "@mui/material";
import { getEmailApiUrl } from '../utils/getEmailApiUrl';

export default function BBFLeadCaptureModal({ show, setShow, markLeadCaptured }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    // basic email check (kept from your version)
    if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
      alert("Please enter a valid email address.");
      return;
    }
    setLoading(true);

    try {
      // ✅ new endpoint + minimal payload
      const response = await fetch(getEmailApiUrl('/subscribe'), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          first_name: name || null,
          purpose: "subscribe"
        })
      });

      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        // server sends { error: "Missing required field: email" } etc.
        throw new Error(data?.error || "We couldn’t process your request. Please try again in a moment.");
      }

      const SUCCESS_ALERT =
        "✅ Thanks! Check your email for a confirmation link to finish signing up. If you don't see it in a minute, check your Spam/Promotions folder.";


      if (data?.success) {
        alert(SUCCESS_ALERT);
        setSubmitted(true);
        markLeadCaptured?.(); // disable future popups
      } else {
        // unexpected but safe fallback
        throw new Error("Unexpected response from server");
      }
    } catch (err) {
      console.error("❌ Subscribe failed:", err);
      alert(err.message || "Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => setShow(false);

  return (
    <Modal
      open={show}
      onClose={handleClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Fade in={show}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            maxWidth: 400,
            width: "90%",
            borderRadius: 2
          }}
        >
          {/* ❌ Close Button */}
          <Button
            onClick={handleClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              minWidth: "auto",
              padding: "4px",
              fontSize: "18px",
              lineHeight: 1
            }}
          >
            ❌
          </Button>

          {submitted ? (
            <>
              <Typography variant="h6" gutterBottom>🎉 Thank you!</Typography>
              <Typography sx={{ mb: 2 }}>
                Check your email for a <strong>confirmation link</strong> to finish signing up.
                If you don’t see it in a minute, check your <em>Spam/Promotions</em> folder.
              </Typography>
              <Button variant="contained" sx={{ mt: 1 }} fullWidth onClick={handleClose}>
                Close
              </Button>
            </>
          ) : (
            <>
              <Typography variant="h6" gutterBottom>
                Join the Fight!
              </Typography>
              <Typography sx={{ mb: 2 }}>
                Stand with those exposing the truth. Get the latest from The Butler Brief — before they try to silence it.
              </Typography>
              <TextField
                fullWidth
                label="Name"
                variant="outlined"
                value={name}
                onChange={(e) => setName(e.target.value)}
                sx={{ mb: 2 }}
              />
              <TextField
                fullWidth
                label="Email"
                variant="outlined"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                sx={{ mb: 2 }}
              />
              <Button
                variant="contained"
                fullWidth
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? "Submitting..." : "Submit"}
              </Button>
            </>
          )}
        </Box>
      </Fade>
    </Modal>
  );
}
